const ACTION_TYPES = {
  DETAILS: 'details',
  SUSPEND: 'Suspend',
  PAUSE: 'Pause',
  RESUME: 'Resume',
  REMOVE: 'Remove',
  ENABLE: 'Enable'
};

const TOP_ALERT_TYPES = {
  SYNC: 'syncrunning', 
  FIRSTSYNC: 'firstsyncrunning', 
  SNAPSHOT: 'snapshot',
  ADDACCOUNT: 'addaccount',
  ACCOUNTSYNCOFF: 'accountsyncoff',
};

export { ACTION_TYPES, TOP_ALERT_TYPES };
